import { render, staticRenderFns } from "./UserInfoCell.vue?vue&type=template&id=58ccf2bc&scoped=true&"
import script from "./UserInfoCell.vue?vue&type=script&lang=js&"
export * from "./UserInfoCell.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoCell.vue?vue&type=style&index=0&id=58ccf2bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ccf2bc",
  null
  
)

export default component.exports